import { render, staticRenderFns } from "./BookingAddressAddon.vue?vue&type=template&id=414b54ab&"
import script from "./BookingAddressAddon.vue?vue&type=script&lang=js&"
export * from "./BookingAddressAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports